import { render, staticRenderFns } from "./ProfessionInfo.vue?vue&type=template&id=268d9306&scoped=true&"
import script from "./ProfessionInfo.vue?vue&type=script&lang=js&"
export * from "./ProfessionInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionInfo.vue?vue&type=style&index=0&id=268d9306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268d9306",
  null
  
)

export default component.exports